import ExtractionTitle from './ExtractionTitle';
export default ExtractionTitle;